<template>
  <div>
    <inputs :title="title" :type="type" :barcode="barcode" :fabrics="fabrics" />
  </div>
</template>

<script>
import Inputs from "./components/Inputs";
export default {
  components: {
    Inputs,
  },
  data() {
    return {
      title: "Scan Fabric For Repair Shirt",
      type: "repair",
      barcode: true,
      fabrics: false,
    };
  },
};
</script>
